module.exports = __webpack_public_path__ + "img/eeszt-logo.e851ce07.svg";